import { parseInventoryQuantity } from './inventoryInputs';

export const hasProductPackFields = data =>
  ['packBarcode', 'packQuantity'].some(key => Object.prototype.hasOwnProperty.call(data, key));

export function validateProductPack({ barcode, packBarcode, packQuantity }) {
  const code = String(packBarcode ?? '').trim();
  const rawQuantity = String(packQuantity ?? '').trim();
  if (!code && !rawQuantity) return '';
  if (!code || !rawQuantity) return 'Вкажіть штрихкод пачки та кількість у пачці разом';
  if (code.length > 80) return 'Штрихкод пачки має містити не більше 80 символів';
  const quantity = parseInventoryQuantity(rawQuantity);
  if (quantity == null || quantity < 2)
    return 'Кількість у пачці має бути цілим числом від 2 до 2147483647';
  if (
    code.toLowerCase() ===
    String(barcode ?? '')
      .trim()
      .toLowerCase()
  )
    return 'Штрихкод пачки має відрізнятися від штрихкоду одиниці';
  return '';
}

export const productPackPayload = data => ({
  packBarcode: String(data.packBarcode ?? '').trim() || null,
  packQuantity: String(data.packQuantity ?? '').trim() === '' ? null : Number(data.packQuantity),
});
